import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sizeGB'
})
export class SizeGBPipe implements PipeTransform {

  transform(value: number): string {
    let sizeInput = (value/1073741824).toFixed(2);
    return sizeInput+" GB";
  }

}
